import { Component, OnInit } from '@angular/core';

import { DynamicDialogRef, DynamicDialogConfig, DialogService } from 'primeng/dynamicdialog';

import { HTTPService, HelperService, DataService } from 'app/services';

import { SubTypePlaceholder, SubSubTypePlaceholder, TypePlaceholder } from 'app/constants/itemType.constants';

import { DeleteCategoryDialogComponent } from '../delete-category-dialog/delete-category-dialog.component';
import { DeleteCategoryEnhancedDialogComponent } from '../delete-category-enhanced-dialog/delete-category-enhanced-dialog.component';

@Component({
  selector: 'app-create-update-category',
  templateUrl: './create-update-category.component.html',
  styleUrls: ['./create-update-category.component.scss'],
})
export class CreateUpdateCategoryComponent implements OnInit {
  subTypePlaceholder = SubTypePlaceholder;
  subSubTypePlaceholder = SubSubTypePlaceholder;
  typePlaceholder = TypePlaceholder;

  isEnhancedGlobalSearchEnabled: boolean = false;
  isLoading: boolean = false;
  categories = [];
  categoryResults: any[] = [];
  headerOptions: any = {
    categoryItemType: true,
    categoryType: true,
  };
  preAppliedFilter = { categoryItemType: '' };
  subSubIndex: any = -1;
  categoryItemType: string = 'labor';
  categoryData: any = {};
  subCategories: any = [];
  subSubCategories: any = [];
  selectedCategory: any = '';
  selectedSubCategory: any = '';
  selectedSubSubCategory: any = '';

  isShowNewCategory: boolean = false;
  isShowEditCategory: boolean = false;

  isShowSubCategory: boolean = false;
  isShowEditSubCategory: boolean = false;

  isShowEditSubsubCategory: boolean = false;
  isShowSubsubCategory: boolean = false;

  isSubCategotiesLoading: boolean = false;

  subCategoryType: any = '';
  subSubCategoryType: any = '';

  constructor(
    private httpService: HTTPService,
    public helperService: HelperService,
    private dynamicDialogRef: DynamicDialogRef,
    private dialogService: DialogService,
    public dConfig: DynamicDialogConfig,
    private dataService: DataService
  ) {}

  ngOnInit() {}

  getAllCategories() {
    this.isLoading = true;
    const query: any = {};
    if (this.categoryItemType) query.itemType = this.categoryItemType;
    this.httpService.getPricingCategories(query).then((res: any) => {
      this.categories = res.categories;
      this.categories.forEach((item) => {
        item['isCollapse'] = false;
      });

      if (this.dConfig.data && this.dConfig.data.id) {
        query.id = this.dConfig.data.id;
        this.httpService.getPricingCategoriesById(query).then((res: any) => {
          if (res.category) {
            this.getSubcategories(res.category);
            this.categoryAccordion(res.category);
          }

          if (res.subCategory) {
            this.getSubSubcategories(res.category, res.subCategory, 0);

            this.subCategoryAccordion(res.subCategory);
          }
          delete this.dConfig.data.id;
        });
      }
      this.isLoading = false;
    });
  }

  handleCloseModal(isSuccess?: boolean) {
    this.dataService.sendData(this.dataService.typeAdd('category-list', 'services'));
    this.dynamicDialogRef.close();
  }

  // deleteCategory(name: string, type: string, category: any, subCategory?: any, subSubCategory?: any) {
  deleteCategory(categoryLevel: string, codeId: string, category: any, subCategory: any) {
    console.log(categoryLevel, codeId);

    // const categoryData = {
    //   name: name,
    //   categoryId: category.categoryId,
    // };

    // if (subCategory?.subCategoryId) {
    //   categoryData['subCategoryId'] = subCategory.subCategoryId;
    // }

    // if (subSubCategory?.subSubCategoryId) {
    //   categoryData['subSubCategoryId'] = subSubCategory.subSubCategoryId;
    // }

    const ref = this.dialogService.open(DeleteCategoryEnhancedDialogComponent, {
      width: '1200px',
      styleClass: 'add-dialog overflow-initial delete-category-dialog',
      showHeader: false,
      data: {
        codeId,
        itemType: this.categoryItemType,
        categoryLevel: categoryLevel,
        // isOnlyDelete: false,
        // newCategoryData: categoryData,
        // categoryList: [],
        // catType: type,
      },
    });
    const onClose = ref.onClose.subscribe(({ isSuccess, data, selectedName }) => {
      if (isSuccess) {
        if (categoryLevel === 'subCategory') {
          this.getSubcategories(category);
        } else if (categoryLevel === 'subSubCategory') {
          this.getSubSubcategories(category, subCategory, this.subSubIndex);
        } else {
          this.getAllCategories();
        }
      }
      onClose.unsubscribe();
    });

    // const ref = this.dialogService.open(DeleteCategoryDialogComponent, {
    //   width: '1200px',
    //   styleClass: 'add-dialog overflow-initial delete-category-dialog',
    //   showHeader: false,
    //   data: {
    //     type: this.categoryItemType,
    //     isOnlyDelete: false,
    //     newCategoryData: categoryData,
    //     categoryList: [],
    //     catType: type,
    //   },
    // });
    // const onClose = ref.onClose.subscribe(({ isSuccess, data, selectedName }) => {
    //   if (isSuccess) {
    //     if (type === 'subCategory') {
    //       this.getSubcategories(category);
    //     } else if (type === 'subSubCategory') {
    //       this.getSubSubcategories(category, subCategory, this.subSubIndex);
    //     } else {
    //       this.getAllCategories();
    //     }
    //   }
    //   onClose.unsubscribe();
    // });
  }

  filterChange(filter: any) {
    if (this.dConfig.data && this.dConfig.data.itemType) {
      const itemType = this.dConfig.data.itemType;
      this.preAppliedFilter.categoryItemType = itemType;
      this.categoryItemType = this.preAppliedFilter.categoryItemType;
      this.dConfig.data.itemType = '';
    } else {
      this.categoryItemType = filter.categoryItemType;
    }
    this.getAllCategories();
  }

  handleCreateNewCategory(action = false) {
    this.isShowNewCategory = action;
    this.isShowEditCategory = false;
    this.isShowSubCategory = false;
    this.isShowEditSubCategory = false;
    this.isShowEditSubsubCategory = false;
    this.isShowSubsubCategory = false;

    this.categoryData.categoryName = '';
    this.categoryData.categoryId = '';
  }

  handleChangeCategory(type, e) {
    this.categoryData[type] = e;
  }

  categoryAccordion(data) {
    this.selectedCategory = '';
    this.isShowNewCategory = false;
    this.isShowEditCategory = false;
    this.isShowSubCategory = false;
    this.isShowSubsubCategory = false;
    this.categoryData = {};
    this.selectedCategory = data.categoryId;
    this.categories.forEach((item) => {
      if (data.categoryId === item.categoryId) {
        item['isCollapse'] = !item.isCollapse;
      } else {
        item['isCollapse'] = false;
      }
    });
  }

  subCategoryAccordion(subCat) {
    this.selectedSubCategory = subCat.subCategoryId;
    this.subCategories.forEach((item) => {
      if (subCat.subCategoryId === item.subCategoryId) {
        item['isCollapse'] = !item.isCollapse;
      } else {
        item['isCollapse'] = false;
      }
    });
  }

  createCategory() {
    this.isLoading = true;
    this.isShowNewCategory = false;
    const data = {
      categoryName: this.categoryData.categoryName,
      itemType: this.categoryItemType,
    };
    this.httpService.createCategory(data).then(
      (res: any) => {
        console.log(res);
        this.categoryData.categoryName = '';
        this.getAllCategories();
      },
      (err) => {
        this.isLoading = false;
        this.helperService.showToaster('error', this.helperService.getErrorMsg(err));
      }
    );
  }

  opneEditCategoryName(category, type, index = 0) {
    this.categoryData = {};
    this.getSubcategories(category);
    this.categoryAccordion(category);
    // this.subCategoryType = type
    this.categoryData.categoryName = category.categoryName;
    this.categoryData.categoryId = category.categoryId;

    this.isShowNewCategory = false;
    this.isShowEditCategory = true;
    this.isShowSubCategory = false;
    this.isShowEditSubCategory = false;
    this.isShowEditSubsubCategory = false;
    this.isShowSubsubCategory = false;
  }

  cancelEditCategory(item) {
    this.isShowNewCategory = false;
    this.isShowEditCategory = false;
    this.isShowSubsubCategory = false;
    this.categoryData.categoryName = '';
    this.categoryData.categoryId = '';
  }

  handleUpdateCategory() {
    this.isLoading = true;
    const data = {
      categoryName: this.categoryData.categoryName,
      itemType: this.categoryItemType,
      categoryId: this.categoryData.categoryId,
    };
    this.httpService.updateCategory(data).then(
      (res: any) => {
        console.log(res);
        this.categoryData.categoryName = '';
        this.categoryData.categoryId = '';
        this.isShowEditCategory = false;
        this.getAllCategories();
        this.isLoading = false;
      },
      (err) => {
        this.helperService.showToaster('error', this.helperService.getErrorMsg(err));
      }
    );
  }

  openSubCategory(action = false, category, type, index = -1) {
    this.getSubcategories(category);
    this.categoryAccordion(category);
    this.selectedCategory = category.categoryId;
    this.categoryData.categoryId = category.categoryId;

    if (!this.isShowEditSubCategory) {
      this.isShowSubCategory = action;
    }
    this.isShowEditSubCategory = false;
    this.isShowNewCategory = false;
    this.isShowEditCategory = false;
    this.isShowEditSubsubCategory = false;
    this.isShowSubsubCategory = false;

    if (!action) {
      this.categoryData.subCategoryName = '';
      this.categoryData.categoryId = '';
    }
  }

  getSubcategories(category, index?) {
    this.subCategories = [];
    this.isSubCategotiesLoading = true;
    this.selectedCategory = category.categoryId;
    this.httpService.getPricingSubCategories(category.categoryId, this.categoryItemType).then(
      (res: any) => {
        if (res && res.subCategories && res.subCategories.length) {
          this.subCategories = res.subCategories;
          this.subCategories.forEach((item) => {
            item['isCollapse'] = false;
          });
          // this.subCategories = category.subCategories;
        } else {
          this.subCategories = [];
        }

        this.isSubCategotiesLoading = false;
      },
      (err) => {
        // this.isSubCatLoading = false;
        this.helperService.showToaster('error', this.helperService.getErrorMsg(err));
      }
    );
  }

  createSubCategory(category, categoryId) {
    this.isShowSubCategory = false;
    this.isLoading = true;
    const data = {
      subCategoryName: this.categoryData.subCategoryName,
      itemType: this.categoryItemType,
      categoryId: categoryId,
    };
    this.httpService.createSubCategory(data).then(
      (res: any) => {
        this.isLoading = false;
        this.categoryData = {};
        this.getSubcategories(category);
      },
      (err) => {
        this.helperService.showToaster('error', this.helperService.getErrorMsg(err));
      }
    );
  }

  handleEditSubCategory(category, subCategory, action, value) {
    this.categoryData = {};

    this.subCategoryType = action;
    this.subCategoryAccordion(subCategory);
    this.categoryData.subCategoryName = subCategory.subCategoryName;
    this.categoryData.subCategoryId = subCategory.subCategoryId;
    this.categoryData.categoryName = category.categoryName;

    this.isShowEditSubCategory = value;
    this.isShowNewCategory = false;
    this.isShowEditCategory = false;
    this.isShowSubCategory = false;
    this.isShowEditSubsubCategory = false;
    this.isShowSubsubCategory = false;
  }

  getSubSubcategories(category, subCategory, index?) {
    this.subSubCategories = [];
    this.selectedSubCategory = subCategory.subCategoryId;
    this.httpService.getPricingSubSubCategories(category.categoryId, subCategory.subCategoryId, this.categoryItemType).then(
      (res: any = {}) => {
        if (res && res.subSubCategories && res.subSubCategories.length) {
          this.subSubCategories = res.subSubCategories;
          this.subSubCategories.forEach((item) => {
            item['isCollapse'] = false;
          });
        } else {
          this.subSubCategories = [];
        }
        this.isLoading = false;
        
      },
      (err) => {
        this.helperService.showToaster('error', this.helperService.getErrorMsg(err));
      }
    );
  }

  updateSubCategory(category, categoryId) {
    this.isLoading = true;
    this.isShowEditSubCategory = false;
    const data = {
      itemType: this.categoryItemType,
      categoryId: categoryId,
      subCategoryId: this.categoryData.subCategoryId,
      subCategoryName: this.categoryData.subCategoryName,
    };
    this.httpService.updateSubCategory(data).then(
      (res: any) => {
        this.getSubcategories(category);
        console.log(res);
        this.isLoading = false;
      },
      (err) => {
        this.helperService.showToaster('error', this.helperService.getErrorMsg(err));
      }
    );
  }

  openNewSubsubCategory(value, action, item, subCategory, index) {
    this.categoryData = {};
    this.subCategoryAccordion(subCategory);
    this.subSubIndex = index;
    this.subSubCategoryType = action;
    this.categoryData.categoryId = item.categoryId;
    this.categoryData.subCategoryId = subCategory.subCategoryId;
    this.isShowSubsubCategory = value;

    this.isShowNewCategory = false;
    this.isShowEditCategory = false;
    this.isShowSubCategory = false;
    this.isShowEditSubCategory = false;
    this.isShowEditSubsubCategory = false;
  }

  createSubSubCategory(category, subCategory) {
    this.isLoading = true;
    this.isShowSubsubCategory = false;
    const data = {
      itemType: this.categoryItemType,
      subSubCategoryName: this.categoryData.subSubCategoryName,
      categoryId: this.categoryData.categoryId,
      subCategoryId: this.categoryData.subCategoryId,
    };
    this.httpService.createSubSubCategory(data).then(
      (res: any) => {
        console.log(res);
        this.getSubSubcategories(category, subCategory, this.subSubIndex);
        this.categoryData = {};
        this.isLoading = false;
        this.isShowSubsubCategory = false;
      },
      (err) => {
        this.helperService.showToaster('error', this.helperService.getErrorMsg(err));
      }
    );
  }

  openEditSubsubCategory(value, action, category, subCategory, subSubCategory, index) {
    // this.subCategoryAccordion(subCategory);
    this.selectedSubSubCategory = subSubCategory.subSubCategoryId;
    this.subSubCategoryType = action;
    this.subSubIndex = index;
    this.categoryData.subSubCategoryId = subSubCategory.subSubCategoryId;
    this.categoryData.subSubCategoryName = subSubCategory.subSubCategoryName;
    this.categoryData.categoryId = category.categoryId;
    this.categoryData.subCategoryId = subCategory.subCategoryId;

    this.isShowEditSubsubCategory = value;
    this.isShowNewCategory = false;
    this.isShowEditCategory = false;
    this.isShowSubCategory = false;
    this.isShowEditSubCategory = false;
    this.isShowSubsubCategory = false;
  }

  updateSubSubCategory(category, subCategory) {
    this.isLoading = true;
    this.isShowEditSubsubCategory = false;
    const data = {
      itemType: this.categoryItemType,
      categoryId: this.categoryData.categoryId,
      subCategoryId: this.categoryData.subCategoryId,
      subSubCategoryId: this.categoryData.subSubCategoryId,
      subSubCategoryName: this.categoryData.subSubCategoryName,
    };
    this.httpService.updateSubSubCategory(data).then(
      (res: any) => {
        console.log(res);
        this.getSubSubcategories(category, subCategory, this.subSubIndex);
        this.isLoading = false;
      },
      (err) => {
        this.helperService.showToaster('error', this.helperService.getErrorMsg(err));
      }
    );
  }
}
